var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "#FF2D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 15.1667H14.3333C14.7942 15.1667 15.1667 14.7942 15.1667 14.3333V9.33333C15.1667 8.8725 14.7942 8.5 14.3333 8.5H9.33333C8.8725 8.5 8.5 8.8725 8.5 9.33333V14.3333C8.5 14.7942 8.8725 15.1667 9.33333 15.1667ZM17.6667 15.1667H22.6667C23.1275 15.1667 23.5 14.7942 23.5 14.3333V9.33333C23.5 8.8725 23.1275 8.5 22.6667 8.5H17.6667C17.2058 8.5 16.8333 8.8725 16.8333 9.33333V14.3333C16.8333 14.7942 17.2058 15.1667 17.6667 15.1667ZM9.33333 23.5H14.3333C14.7942 23.5 15.1667 23.1275 15.1667 22.6667V17.6667C15.1667 17.2058 14.7942 16.8333 14.3333 16.8333H9.33333C8.8725 16.8333 8.5 17.2058 8.5 17.6667V22.6667C8.5 23.1275 8.8725 23.5 9.33333 23.5ZM20.1667 23.5C22.005 23.5 23.5 22.005 23.5 20.1667C23.5 18.3283 22.005 16.8333 20.1667 16.8333C18.3283 16.8333 16.8333 18.3283 16.8333 20.1667C16.8333 22.005 18.3283 23.5 20.1667 23.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.2ad9263cdf1e59204d31bed3b9b2eb7e.svg";
export { ForwardRef as ReactComponent };